/** A worker's own schedule (ADR 0048): the agent's replies in Talk, the bookings on Today, and their reminders. */
export const schedule = {
    "card.schedule": "Schedule",
    "schedule.saved": "Saved to your schedule:",
    "schedule.saved_clash": "Saved. It overlaps with something already on your schedule; call the customer if one of them has to move:",
    "schedule.list": "On your schedule:",
    "schedule.empty": "Nothing on your schedule. To add a booking, say: save my booking for tomorrow 2 to 3 pm.",
    "schedule.free_day": "Nothing booked that day.",
    "schedule.cancelled": "Taken off your schedule:",
    "schedule.none_to_cancel": "I found no booking then. Ask “what is on my schedule?” to see them all.",
    "schedule.which": "More than one booking fits. Say its time too:",
    "schedule.when": "{day}, {start} – {end}",
    "schedule.today": "Today",
    "schedule.tomorrow": "Tomorrow",
    "schedule.job": "GigSync job: {when}",
    "schedule.title": "Your bookings",
    "schedule.hint": "Bookings you told your agent in Talk. It will not agree to a job at these times.",
    "schedule.delete": "Delete",
    "schedule.delete_named": "Delete {when}",
    "schedule.soon": "Starts in {minutes} min",
    "schedule.remind_title": "Booking at {time}",
    "schedule.remind_body": "Starts in {minutes} minutes.",
};
//# sourceMappingURL=schedule.js.map